module.exports = __webpack_public_path__ + "static/media/about img5.68856498.png";